import { Injectable, Inject } from '@angular/core';
import { $uibModal } from './ajs-upgraded-providers';
declare var angular: any;
@Injectable({
    providedIn: 'root'
})
export class UtilsService {

    constructor(private $modal:$uibModal) {
    }

    OpenModal(msg, template, controller, data, cssClass, sc, leaveOpen) {
            data = data || {};
            data.text = msg;
            var modal: any = {
                windowClass: cssClass || '',
                templateUrl: template || 'ng1/src/common/modalView.html',
                controller: controller || 'ModalController',
                resolve: {
                    data: data
                }
            };

            if (sc) {
                modal.scope = sc;
            }
            if (leaveOpen) {
                modal.backdrop = 'static';
                modal.keyboard = false;
            }

            return this.$modal.open(modal);
        }

        IsNull(val) {
            return val === null || val === undefined;
        }

        IsNullOrEmpty(val) {
            return this.IsNull(val) || val === '';
        }

        IsTypeheadEmpty(val) {
            return !val || val === ' ' || val === '[$empty$]';
        }

        MinutesToHours(minutes, roundTo) {

            var hours = parseFloat(minutes) / 60;
            return hours.toFixed(roundTo || 0);
        }

        AddBlankOption(filterDataSource, label) {

            if (angular.isArray(filterDataSource)) {
                filterDataSource.unshift({ id: null, value: label || 'Blank' });
            }
        }

        Swap(source, target, property) {
            var sourceValue = source[property];
            source[property] = target[property];
            target[property] = sourceValue;
        }

        GetPropertyByPath(obj, path) {
            var paths = path.split('.');
            var current = obj;
            var i;

            for (i = 0; i < paths.length; ++i) {
                if (current[paths[i]] === undefined) {
                    return undefined;
                } else {
                    current = current[paths[i]];
                }
            }
            return current;
        }

        IsJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }


    }